import { API } from "../../Services"
export const customersList = (query='') =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_CUSTOMERS_LIST",
        })
         API.customers(query).then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data.customers
            data.map((customer,customerIndex)=>{
                customer.value = customer.id
                customer.label = `${customer.firstName} ${customer.lastName}`
            })
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_CUSTOMERS_LIST",
                    payload:{data:data,totalRecords:res.data.totalRecords},
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_CUSTOMERS_LIST",
            })
        })
    }
}